import { useEffect, useState } from "react";
import { getAllLanguages } from "../services";
import { useLanguageService } from "./useLanguageService";

interface Language {
  code: string;
  name: string;
  url: string;
}

export const useLanguageManagement = () => {
  const [availableLanguages, setAvailableLanguages] = useState<Language[]>([]);
  const { handleSaveData } = useLanguageService();

  useEffect(() => {
    const getAllLanguagesList = async () => {
      const result: any = await getAllLanguages();
      setAvailableLanguages(result?.results);
    };
    getAllLanguagesList();
  }, []);

  return {
    availableLanguages,
    handleSaveData,
  };
};
